const ONE_MEGABTYE = 1000000;

module.exports = {
	ONE_MEGABTYE,
};
